import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export const generarSceneCorgi = (nombre, ref) => {
  const scene = new THREE.Scene();
  scene.userData.nombre = nombre;
  // const element2 = document.createElement("div");
  const element2 = ref.current;
  // element2.className = "col-md-4 col-lg-4 mt-3 mb-3";
  //Correcto div
  // element2.className = "contenedor-item";
  const element = document.createElement("div");
  // element.className = "list-item col-md-4 col-lg-3";
  element.className = "list-item-corgi";
  element2.appendChild(element);
  element2.id = "id-corgi";
  const sceneElement = document.createElement("div");

  // element.style.zIndex = "99999999";
  // element2.style.zIndex = "99999999";
  // sceneElement.style.zIndex = "99999999";

  element.style.zIndex = "999";
  element2.style.zIndex = "999";
  sceneElement.style.zIndex = "999";
  sceneElement.className = "scene-destacados";
  ///////

  /////////
  element.appendChild(sceneElement);
  sceneElement.id = "div-scene-corgi";
  const descriptionElement = document.createElement("div");
  // descriptionElement.innerText = "Escena principal ";
  element.appendChild(descriptionElement);

  // the element that represents the area we want to render the scene
  scene.userData.element = sceneElement;

  const light = new THREE.DirectionalLight(0xffffff, 0.5);
  light.position.set(1, 1, 1);
  //  scene.add(light);
  // console.log("scene es, ", scene);
  // scene.background = new THREE.Color("#FF0000");
  // scene.background = new THREE.Color("rgb(0, 200, 0, 0.1)");
  scene.background = null;
  // scene.background = "transparent";
  const camera = new THREE.PerspectiveCamera(50, 1, 1, 10);
  camera.position.z = 2;
  // camera.rotation.y = -1;
  scene.userData.camera = camera;

  // const controls = new OrbitControls(
  //   scene.userData.camera,
  //   scene.userData.element
  // );
  // controls.minDistance = 2;
  // controls.maxDistance = 5;
  // controls.enablePan = false;
  // controls.enableZoom = true;
  // scene.userData.controls = controls;

  /**
   * Lights
   */
  const directionalLight = new THREE.DirectionalLight("#ffffff", 0.5);
  directionalLight.position.set(0, 0, 1);
  scene.add(directionalLight);
  // const directionalLight2 = new THREE.DirectionalLight("#ffffff", 1);
  // directionalLight2.position.set(0, 0, -4);
  // scene.add(directionalLight2);
  // const directionalLight3 = new THREE.DirectionalLight("#ffffff", 1);
  // directionalLight3.position.set(2, 0, -0.5);
  // scene.add(directionalLight3);
  // const directionalLight4 = new THREE.DirectionalLight("#ffffff", 1);
  // directionalLight4.position.set(-2, 2, -0.5);
  // scene.add(directionalLight4);
  //   const rectAreaLight = new THREE.RectAreaLight(0xffffff, 0, 1, 2);
  //   scene.add(rectAreaLight);
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.9);
  scene.add(ambientLight);
  //////
  // const loader = new THREE.TextureLoader();
  // loader.load("./rectangulo.png", function (texture) {
  //   scene.background = texture;
  // });
  return [scene, element2];
};
